import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";

const StyledCheckbox = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  max-width: 100%;

  &:hover input[type="checkbox"] {
    border-color: ${({ theme }) => theme.colors.tone.black};
  }

  &.disabled {
    cursor: initial;

    &:hover input[type="checkbox"] {
      border-color: ${({ theme }) => theme.colors.tone.silver};
    }
  }

  input[type="checkbox"] {
    appearance: none;
    width: 18px;
    min-width: 18px;
    height: 18px;
    fill: none;
    border-radius: 1px;
    border: 1px solid ${({ theme }) => theme.colors.tone.silver};
    box-sizing: border-box;
    display: flex;
    place-items: center;
    place-content: center;
    margin: 0;
    cursor: pointer;

    &.align-center {
      align-self: center;
    }

    &.align-start {
      align-self: start;
      margin-top: 3px;
    }

    &.disabled {
      border-color: ${({ theme }) => theme.colors.tone.marble};
    }

    &.focus-visible {
      border-color: ${({ theme }) => theme.colors.semantic.blue};
    }

    &::before {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      background-color: ${({ theme }) => theme.colors.tone.black};
      transform: scale(0);
      transition: all 250ms ease-in-out;
    }

    &:checked {
      border-color: ${({ theme }) => theme.colors.tone.black};

      &::before {
        transform: scale(1);
      }

      &.disabled {
        border-color: ${({ theme }) => theme.colors.tone.silver};

        &:before {
          background-color: ${({ theme }) => theme.colors.tone.anthraciteLight};
        }
      }
    }
  }
`;

const Label = styled(Text)`
  margin-left: ${({ theme }) => theme.space.space8};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  line-height: 20.11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.tone.black};
`;

export { StyledCheckbox, Label };
